<script lang="ts">
	import { getContextScope } from '$lib/js/helpers/i18n'

  export let breadcrumbs: {name: string, url_path: string}[];
	const scope = getContextScope()
</script>


<div class="breadcrumbs">
  {#each breadcrumbs.slice(0, -1) as link}
    <a href="/{scope}/{link.url_path}">{link.name}</a>
    <span>></span>
  {/each}
</div>


<style lang="scss">
  .breadcrumbs {
    margin-bottom: 15px;

    a {
      display: inline-block;
      color: black;
      padding: 4px 0;

      &:hover {
        color: var(--main);
      }
    }

    span {
      margin: 0 10px;

      &:last-child {
        display: none;
      }
    }
  }
</style>
